'use client';

import { AccordionProfileEnum, cn, TDetailsModalProps } from 'types';
import { CustomModal } from '../custom-modal';
import { Accordion } from '../accordion';

export const DetailsSingleTab = ({
  modalDetails,
  modalTitle,
  onCloseClick,
  open,
  className = '',
  modalFooter,
}: TDetailsModalProps) => {
  return (
    <CustomModal
      open={open}
      onCloseClick={onCloseClick}
      className={cn('w-[47.5rem]', className)}
      headerTitle={modalTitle}
    >
      <div
        className={cn(
          'flex flex-col gap-8 p-6 overflow-auto noScrollbar',
          modalFooter ? 'max-h-[calc(100vh_-_14.8rem)]' : 'max-h-[calc(100vh_-_10.375rem)]'
        )}
      >
        {modalDetails?.map((detailItem, key) => (
          <div className="flex flex-col gap-4" key={key}>
            {detailItem?.sectionTitle && <h4 className="text-lg/[175%] font-extrabold">{detailItem?.sectionTitle}</h4>}
            {detailItem?.sectionData?.length > 0 &&
              (detailItem?.isSectionLoading ? (
                <>Loading...</>
              ) : (
                <div className="flex flex-col">
                  {detailItem?.sectionData?.map((sectionDataItem, index) => (
                    <Accordion
                      accordionProfile={AccordionProfileEnum.MEDIUM}
                      primaryLabel={sectionDataItem?.title}
                      key={index}
                      defaultOpen={sectionDataItem?.isChildOpen}
                      className="tw-border-y !border-neutralGrey has-[+_.tw-accordion]:border-b-0"
                      triggerClassName="aria-expanded:bg-lightGrey"
                      contentClassName="aria-expanded:pt-0"
                    >
                      {sectionDataItem?.detailsChild}
                    </Accordion>
                  ))}
                </div>
              ))}
          </div>
        ))}
      </div>
      {modalFooter && <div className="p-6 border-t border-t-neutralGrey">{modalFooter}</div>}
    </CustomModal>
  );
};
